function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "769px",
    height: "505px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.947
    },
    fill: "#8f8f8f",
    d: "M 43.5,-0.5 C 270.833,-0.5 498.167,-0.5 725.5,-0.5C 749.039,2.37368 763.373,15.3737 768.5,38.5C 768.5,181.167 768.5,323.833 768.5,466.5C 763.712,485.956 751.712,498.623 732.5,504.5C 500.167,504.5 267.833,504.5 35.5,504.5C 16.2923,498.626 4.29227,485.96 -0.5,466.5C -0.5,323.833 -0.5,181.167 -0.5,38.5C 5.39996,15.5996 20.0666,2.59959 43.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 40.5,7.5 C 269.5,7.33333 498.5,7.5 727.5,8C 744.346,11.1784 755.18,21.0117 760,37.5C 760.667,180.167 760.667,322.833 760,465.5C 756.202,482.631 745.702,493.131 728.5,497C 498.833,497.667 269.167,497.667 39.5,497C 22.3244,493.158 11.8244,482.658 8,465.5C 7.33333,322.833 7.33333,180.167 8,37.5C 13.0031,20.9904 23.8365,10.9904 40.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ec2026",
    d: "M 382.5,75.5 C 372.215,85.6238 362.381,96.2905 353,107.5C 315.738,161.444 309.738,218.777 335,279.5C 346.396,303.625 362.563,323.958 383.5,340.5C 383.5,340.833 383.5,341.167 383.5,341.5C 330.224,379.97 272.891,387.137 211.5,363C 154.884,335.634 121.717,290.801 112,228.5C 106.827,150.117 138.661,92.6173 207.5,56C 269.606,29.723 327.939,36.223 382.5,75.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f89e1d",
    d: "M 383.5,341.5 C 383.5,341.167 383.5,340.833 383.5,340.5C 424.868,306.487 446.202,262.487 447.5,208.5C 445.902,154.644 424.569,110.644 383.5,76.5C 437.287,36.8601 495.287,29.6934 557.5,55C 614.113,82.9646 646.78,128.298 655.5,191C 660.089,259.148 634.423,312.482 578.5,351C 528.601,380.132 476.601,384.465 422.5,364C 408.561,357.843 395.561,350.343 383.5,341.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f16a21",
    d: "M 382.5,75.5 C 383.167,75.5 383.5,75.8333 383.5,76.5C 424.569,110.644 445.902,154.644 447.5,208.5C 446.202,262.487 424.868,306.487 383.5,340.5C 362.563,323.958 346.396,303.625 335,279.5C 309.738,218.777 315.738,161.444 353,107.5C 362.381,96.2905 372.215,85.6238 382.5,75.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8a530",
    d: "M 642.5,294.5 C 644.288,293.378 646.288,293.211 648.5,294C 647.08,295.53 646.08,297.363 645.5,299.5C 644.999,297.345 643.999,295.678 642.5,294.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faab40",
    d: "M 649.5,293.5 C 650.5,293.5 651.5,293.5 652.5,293.5C 652.351,294.552 652.517,295.552 653,296.5C 653.908,294.561 655.408,293.561 657.5,293.5C 657.799,295.604 657.466,297.604 656.5,299.5C 655.808,298.975 655.308,298.308 655,297.5C 654.692,298.308 654.192,298.975 653.5,299.5C 652.5,298.167 651.5,298.167 650.5,299.5C 649.534,297.604 649.201,295.604 649.5,293.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#252122",
    d: "M 619.5,399.5 C 622.833,399.5 626.167,399.5 629.5,399.5C 629.5,420.167 629.5,440.833 629.5,461.5C 626.167,461.5 622.833,461.5 619.5,461.5C 619.657,460.127 619.49,458.793 619,457.5C 604.923,467.263 593.59,464.596 585,449.5C 580.167,434.644 584.667,423.81 598.5,417C 606.166,415.267 613,416.767 619,421.5C 619.5,414.174 619.666,406.841 619.5,399.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#282425",
    d: "M 329.5,403.5 C 332.833,403.5 336.167,403.5 339.5,403.5C 339.5,408.167 339.5,412.833 339.5,417.5C 344.5,417.5 349.5,417.5 354.5,417.5C 354.5,420.5 354.5,423.5 354.5,426.5C 349.5,426.5 344.5,426.5 339.5,426.5C 339.062,434.943 339.562,443.277 341,451.5C 344.553,453.837 348.386,454.17 352.5,452.5C 355.93,454.519 356.93,457.352 355.5,461C 348.833,464.333 342.167,464.333 335.5,461C 333.622,459.457 332.122,457.624 331,455.5C 329.58,445.914 329.08,436.247 329.5,426.5C 326.5,426.5 323.5,426.5 320.5,426.5C 320.5,423.5 320.5,420.5 320.5,417.5C 323.5,417.5 326.5,417.5 329.5,417.5C 329.5,412.833 329.5,408.167 329.5,403.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#242021",
    d: "M 148.5,434.5 C 147.507,443.318 147.173,452.318 147.5,461.5C 144.5,461.5 141.5,461.5 138.5,461.5C 138.5,446.833 138.5,432.167 138.5,417.5C 141.5,417.5 144.5,417.5 147.5,417.5C 147.34,419.199 147.506,420.866 148,422.5C 154.015,416.274 161.182,414.774 169.5,418C 171.96,419.458 174.127,421.291 176,423.5C 181.711,416.863 188.877,414.696 197.5,417C 203.776,418.942 207.61,423.109 209,429.5C 209.5,440.161 209.667,450.828 209.5,461.5C 206.5,461.5 203.5,461.5 200.5,461.5C 200.865,451.443 200.365,441.443 199,431.5C 194.755,424.983 189.255,423.817 182.5,428C 180.959,429.579 179.792,431.413 179,433.5C 178.5,442.827 178.334,452.161 178.5,461.5C 175.5,461.5 172.5,461.5 169.5,461.5C 169.926,451.088 169.426,440.754 168,430.5C 162,423.833 156,423.833 150,430.5C 149.209,431.745 148.709,433.078 148.5,434.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#262223",
    d: "M 233.5,416.5 C 237.846,416.334 242.179,416.501 246.5,417C 249.242,418.07 251.742,419.57 254,421.5C 254.49,420.207 254.657,418.873 254.5,417.5C 257.833,417.5 261.167,417.5 264.5,417.5C 264.5,432.167 264.5,446.833 264.5,461.5C 261.167,461.5 257.833,461.5 254.5,461.5C 254.657,460.127 254.49,458.793 254,457.5C 243.824,465.621 233.824,465.288 224,456.5C 217.484,446.572 216.817,436.238 222,425.5C 225.161,421.491 228.994,418.491 233.5,416.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#282425",
    d: "M 285.5,416.5 C 294.981,415.415 303.981,416.915 312.5,421C 310.709,423.414 309.043,425.914 307.5,428.5C 301.503,424.626 295.169,423.792 288.5,426C 284.341,429.199 284.675,431.865 289.5,434C 294.552,434.744 299.552,435.744 304.5,437C 314.194,441.697 316.027,448.531 310,457.5C 297.719,465.555 285.552,465.388 273.5,457C 275.006,454.667 276.673,452.5 278.5,450.5C 284.705,454.185 291.371,455.352 298.5,454C 302.279,452.596 303.279,450.096 301.5,446.5C 295.543,444.895 289.543,443.395 283.5,442C 276.786,438.56 274.286,433.06 276,425.5C 278.406,421.592 281.572,418.592 285.5,416.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#272324",
    d: "M 405.5,434.5 C 405.5,437.167 405.5,439.833 405.5,442.5C 394.48,442.168 383.48,442.501 372.5,443.5C 372.624,444.107 372.957,444.44 373.5,444.5C 376.411,453.126 382.411,456.293 391.5,454C 393.833,452.833 396.167,451.667 398.5,450.5C 405.554,455.964 404.554,459.797 395.5,462C 372.861,466.03 362.028,456.53 363,433.5C 368.459,418.354 378.959,413.188 394.5,418C 401.049,421.603 404.716,427.103 405.5,434.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#242021",
    d: "M 425.5,461.5 C 422.833,461.5 420.167,461.5 417.5,461.5C 417.5,446.833 417.5,432.167 417.5,417.5C 420.167,417.5 422.833,417.5 425.5,417.5C 425.34,419.199 425.506,420.866 426,422.5C 431.265,416.575 437.765,414.908 445.5,417.5C 443.895,420.314 442.895,423.314 442.5,426.5C 435.837,423.936 430.671,425.602 427,431.5C 425.605,441.434 425.105,451.434 425.5,461.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#272324",
    d: "M 465.5,416.5 C 469.846,416.334 474.179,416.501 478.5,417C 481.965,417.65 484.965,419.15 487.5,421.5C 485.8,424.039 484.3,426.705 483,429.5C 476.869,424.804 470.369,424.304 463.5,428C 458.85,432.574 457.35,438.074 459,444.5C 461.086,450.423 465.253,453.423 471.5,453.5C 475.444,453.519 479.111,452.519 482.5,450.5C 484.826,452.829 486.326,455.496 487,458.5C 473.969,466.406 462.303,464.74 452,453.5C 443.7,436.151 448.2,423.818 465.5,416.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#252122",
    d: "M 508.5,416.5 C 512.846,416.334 517.179,416.501 521.5,417C 524.242,418.07 526.742,419.57 529,421.5C 529.49,420.207 529.657,418.873 529.5,417.5C 532.833,417.5 536.167,417.5 539.5,417.5C 539.5,432.167 539.5,446.833 539.5,461.5C 536.167,461.5 532.833,461.5 529.5,461.5C 529.657,460.127 529.49,458.793 529,457.5C 514.923,467.263 503.59,464.596 495,449.5C 490.26,434.526 494.76,423.526 508.5,416.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#242021",
    d: "M 567.5,416.5 C 571.884,416.174 576.217,416.508 580.5,417.5C 579.48,420.605 578.313,423.605 577,426.5C 570.254,424.037 565.254,426.037 562,432.5C 561.5,442.161 561.334,451.828 561.5,461.5C 558.5,461.5 555.5,461.5 552.5,461.5C 552.5,446.833 552.5,432.167 552.5,417.5C 555.5,417.5 558.5,417.5 561.5,417.5C 561.343,418.873 561.51,420.207 562,421.5C 563.73,419.598 565.563,417.931 567.5,416.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#615e5f",
    d: "M 417.5,417.5 C 417.5,432.167 417.5,446.833 417.5,461.5C 420.167,461.5 422.833,461.5 425.5,461.5C 422.713,462.477 419.713,462.81 416.5,462.5C 416.171,447.324 416.504,432.324 417.5,417.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfbfb",
    d: "M 237.5,425.5 C 253.985,426.46 258.651,434.46 251.5,449.5C 246.399,453.746 240.732,454.579 234.5,452C 228.096,445.709 226.93,438.542 231,430.5C 232.965,428.45 235.132,426.783 237.5,425.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafafa",
    d: "M 379.5,425.5 C 383.637,425.146 387.637,425.646 391.5,427C 394.321,429.141 395.654,431.975 395.5,435.5C 388.167,435.5 380.833,435.5 373.5,435.5C 373.992,431.169 375.992,427.836 379.5,425.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f9f9",
    d: "M 512.5,425.5 C 528.837,426.504 533.67,434.504 527,449.5C 519.653,455.13 512.653,454.796 506,448.5C 501.031,438.638 503.198,430.971 512.5,425.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f9f9",
    d: "M 602.5,425.5 C 618.837,426.504 623.67,434.504 617,449.5C 609.653,455.13 602.653,454.796 596,448.5C 591.031,438.638 593.198,430.971 602.5,425.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#646162",
    d: "M 148.5,434.5 C 148.5,443.833 148.5,453.167 148.5,462.5C 144.958,462.813 141.625,462.479 138.5,461.5C 141.5,461.5 144.5,461.5 147.5,461.5C 147.173,452.318 147.507,443.318 148.5,434.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5b5859",
    d: "M 405.5,434.5 C 406.477,437.287 406.81,440.287 406.5,443.5C 395.321,443.172 384.321,443.505 373.5,444.5C 372.957,444.44 372.624,444.107 372.5,443.5C 383.48,442.501 394.48,442.168 405.5,442.5C 405.5,439.833 405.5,437.167 405.5,434.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a3637",
    d: "M 647.5,455.5 C 654.486,455.331 656.153,458.164 652.5,464C 645.416,464.475 643.749,461.642 647.5,455.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#908e8e",
    d: "M 648.5,456.5 C 652.235,456.546 653.568,458.213 652.5,461.5C 651.749,460.624 651.249,459.624 651,458.5C 650.333,459.833 649.667,459.833 649,458.5C 648.46,460.135 648.96,461.468 650.5,462.5C 648.461,463.359 647.128,462.526 646.5,460C 646.978,458.697 647.645,457.531 648.5,456.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/masterCard.6413c06b3a0f9208522fc0606afb58d3.svg";
export { ForwardRef as ReactComponent };